/* ECEO : mode visiteur/acheteur, barre cadeaux, Mon mur */
(function () {
  if (window.EceoPP) return;
  var d = document, html = d.documentElement;

  /* ---------- Mode visiteur / acheteur ---------- */
  function syncButtons() {
    var m = html.getAttribute('data-eceo-mode') || 'visiteur';
    d.querySelectorAll('[data-eceo-mode-btn]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-eceo-mode-btn') === m ? 'true' : 'false');
    });
  }
  function setMode(m) {
    html.setAttribute('data-eceo-mode', m);
    try { sessionStorage.setItem('eceo-mode', m); } catch (e) {}
    syncButtons();
    if (m === 'visiteur') {
      var first = d.querySelector('[data-eceo-visit]');
      if (first) setTimeout(function () { first.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 60);
    }
    d.dispatchEvent(new CustomEvent('eceo:mode', { detail: { mode: m } }));
  }
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-eceo-mode-btn]');
    if (b) { e.preventDefault(); setMode(b.getAttribute('data-eceo-mode-btn')); }
  });

  /* ---------- Barre cadeaux : les cadeaux sur la table ---------- */
  var total = null, attrs = null, inCart = null, pending = null, root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var ICONS = {
    envoi: '<svg width="40" height="40" viewBox="0 0 40 40" aria-hidden="true"><rect x="4" y="12" width="22" height="16" rx="2" fill="#E8D3B0" stroke="#141414" stroke-width="1.4"/><path d="M26 16h6l4 5v7H26z" fill="#fff" stroke="#141414" stroke-width="1.4"/><circle cx="11" cy="30" r="3" fill="#fff" stroke="#141414" stroke-width="1.4"/><circle cx="30" cy="30" r="3" fill="#fff" stroke="#141414" stroke-width="1.4"/></svg>',
    marque: '<svg width="40" height="40" viewBox="0 0 40 40" aria-hidden="true"><path d="M8 5h8v28l-4-4-4 4z" fill="#FFCBCF" stroke="#141414" stroke-width="1.4"/><path d="M16 7h8v28l-4-4-4 4z" fill="#899DD2" stroke="#141414" stroke-width="1.4"/><path d="M24 5h8v28l-4-4-4 4z" fill="#A85244" stroke="#141414" stroke-width="1.4"/></svg>',
    petit: '<svg width="40" height="40" viewBox="0 0 40 40" aria-hidden="true"><rect x="11" y="7" width="18" height="26" fill="#fff" stroke="#141414" stroke-width="1.4"/><path d="M20 12v14M16 16l4-3 4 3M17 26l3-3 3 3" fill="none" stroke="#A85244" stroke-width="1.6" stroke-linecap="round"/></svg>',
    poster: '<svg width="40" height="40" viewBox="0 0 40 40" aria-hidden="true"><path d="M6 26 L28 8 a4 4 0 0 1 6 5 L12 31 z" fill="#FDF2DD" stroke="#141414" stroke-width="1.4"/><circle cx="9" cy="28.5" r="3.5" fill="#fff" stroke="#141414" stroke-width="1.4"/><path d="M18 20l8-6" stroke="#A85244" stroke-width="2" stroke-linecap="round"/></svg>',
    stickers: '<svg width="40" height="40" viewBox="0 0 40 40" aria-hidden="true"><rect x="8" y="6" width="24" height="28" rx="2" fill="#fff" stroke="#141414" stroke-width="1.4"/><circle cx="15" cy="14" r="4" fill="#FFCBCF" stroke="#141414" stroke-width="1.2"/><circle cx="25" cy="20" r="4" fill="#899DD2" stroke="#141414" stroke-width="1.2"/><path d="M12 27l4-4 4 4" fill="none" stroke="#A85244" stroke-width="1.6" stroke-linecap="round"/></svg>',
    surprise: '<svg width="40" height="40" viewBox="0 0 40 40" aria-hidden="true"><rect x="6" y="9" width="28" height="22" rx="2" fill="#fff" stroke="#141414" stroke-width="1.4"/><path d="M6 11l14 10 14-10" fill="none" stroke="#141414" stroke-width="1.4"/><path d="M24 25c2-3 5-3 6 0" fill="none" stroke="#A85244" stroke-width="1.6" stroke-linecap="round"/></svg>'
  };
  var LOCK = '<svg class="eg-lock" width="12" height="12" viewBox="0 0 16 16" aria-hidden="true"><rect x="3" y="7" width="10" height="7" rx="1.5" fill="none" stroke="#9a9a9a" stroke-width="1.4"/><path d="M5.5 7V5a2.5 2.5 0 0 1 5 0v2" fill="none" stroke="#9a9a9a" stroke-width="1.4"/></svg>';

  function money(c) {
    var v = c / 100;
    return v.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: v % 1 ? 2 : 0 });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function cfgOf(el) {
    if (!el._cfg) {
      var n = el.querySelector('[data-eg-config]');
      try { el._cfg = JSON.parse(n.textContent); } catch (e) { el._cfg = { tiers: [] }; }
      el._cfg.fill = (el._cfg.fill || []).filter(function (f) { return f && f.id; });
      try { el._attrs0 = JSON.parse(el.getAttribute('data-attrs') || '{}'); } catch (e) { el._attrs0 = {}; }
      el._inCart0 = (el.getAttribute('data-incart') || '').split(',').filter(Boolean).map(Number);
    }
    return el._cfg;
  }
  function slotKey(t) { return t.k || 'Cadeau ' + t.v + ' €'; }
  function isSlot(t) { return t.type === 'petit' || t.type === 'poster' || t.type === 'bienvenue'; }
  // Palier de bienvenue : ajouté seulement si le panier porte le marqueur posé par le lien de l'e-mail
  function tiersOf(el, A) {
    var cfg = cfgOf(el), T = (cfg.tiers || []).slice(), w = cfg.welcome;
    if (w && w.v && A && A[w.key]) {
      T.push({ v: w.v, l: w.l, type: w.type || 'bienvenue', w: 1, ch: w.choices || [], k: w.slot, u: w.u });
      // Un seul poster 21x30 offert : avec le cadeau de bienvenue, le palier 21x30 disparaît
      if (!w.type || w.type === 'bienvenue') T = T.filter(function (tr) { return tr.type === 'bienvenue' || !(tr.k && /\(21x30\)/.test(tr.k)); });
      T.sort(function (a, b) { return a.v - b.v; });
    }
    return T;
  }

  function render(el) {
    var cfg = cfgOf(el), A = attrs || el._attrs0 || {}, T = tiersOf(el, A);
    if (!T.length) return;
    var t = total != null ? total : parseInt(el.getAttribute('data-total') || '0', 10);
    var done = 0, next = null;
    T.forEach(function (tr) { if (t >= tr.v * 100) done++; else if (!next) next = tr; });
    var max = T[T.length - 1].v * 100;
    var msg = next
      ? 'Plus que <b>' + money(next.v * 100 - t) + '</b> pour débloquer : <b>' + esc(next.l.charAt(0).toLowerCase() + next.l.slice(1)) + '</b>' + (next.val ? ' (valeur ' + money(next.val * 100) + ')' : '')
      : '<b>' + esc(el.getAttribute('data-done')) + '</b>';
    var gained = 0; T.forEach(function (tr) { if (t >= tr.v * 100 && tr.val) gained += tr.val * 100; });
    var sub = done ? done + ' cadeau' + (done > 1 ? 'x' : '') + ' dans votre colis' + (gained ? ' : <b>' + money(gained) + ' offerts</b>' : '') : 'Les cadeaux se cumulent, palier après palier';
    var tiles = T.map(function (tr) {
      var on = t >= tr.v * 100, img = cfg.imgs && (cfg.imgs[tr.type] || (tr.type === 'bienvenue' && cfg.imgs.petit));
      var visual = img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="44" height="44">' : (ICONS[tr.type] || (tr.type === 'bienvenue' ? ICONS.petit : ICONS.poster));
      var tag = tr.u ? 'a' : 'div';
      return '<' + tag + (tr.u ? ' href="' + esc(tr.u) + '" title="Voir les posters offerts"' : '') + ' class="eg-tile ' + (on ? 'is-on' : 'is-off') + '"><span class="eg-ic">' + visual + '</span><span class="eg-v">' + (tr.w && tr.type === 'stickers' ? 'Bienvenue' : tr.v + ' €') + '</span><span class="eg-l">' + esc(tr.l) + '</span>' + (tr.val ? '<span class="eg-val" style="display:block;font-size:11px;line-height:1.3;opacity:.7;margin-top:2px">valeur ' + money(tr.val * 100) + '</span>' : '') + (tr.u ? '<span class="eg-see">Voir la liste</span>' : '') + (on ? '<span class="eg-stamp">Débloqué</span>' : LOCK) + '</' + tag + '>';
    }).join('');

    var sug = '';
    if (next && t > 0 && cfg.fill.length) {
      var gap = next.v * 100 - t, pick = null, owned = inCart || el._inCart0 || [];
      var pool = cfg.fill.filter(function (f) { return owned.indexOf(f.pid) === -1; });
      pool.slice().sort(function (a, b) { return a.p - b.p; }).some(function (f) { if (f.p >= gap) { pick = f; return true; } return false; });
      if (!pick) pick = pool.slice().sort(function (a, b) { return b.p - a.p; })[0];
      if (pick) sug = '<div class="eg-sug">' + (pick.img ? '<img src="' + esc(pick.img) + '" alt="" width="46" height="58" loading="lazy">' : '') + '<p>Il manque ' + money(gap) + ' : <b>' + esc(pick.t) + '</b> à ' + money(pick.p) + ' et c’est débloqué.</p><button type="button" data-eg-add="' + pick.id + '">+ ' + money(pick.p) + '</button></div>';
    }

    var choice = '';
    var slots = T.filter(function (tr) { return isSlot(tr) && t >= tr.v * 100 && ((tr.ch && tr.ch.length) || (cfg.choices && cfg.choices.length)); });
    if (slots.length) {
      var active = el._slot && slots.some(function (s) { return slotKey(s) === el._slot; }) ? el._slot : null;
      if (!active) { var free = slots.filter(function (s) { return !A[slotKey(s)]; })[0]; active = slotKey(free || slots[0]); }
      el._slot = active;
      var slotBtns = slots.map(function (s) {
        var k = slotKey(s), v = A[k];
        return '<button type="button" class="eg-slot' + (k === active ? ' is-active' : '') + '" data-eg-slot="' + esc(k) + '"><span>' + esc(s.l) + '</span><b>' + (v ? esc(v) : 'À choisir') + '</b></button>';
      }).join('');
      var cur = A[active], aT = slots.filter(function (s) { return slotKey(s) === active; })[0];
      var CH = aT && aT.ch && aT.ch.length ? aT.ch : (cfg.choices || []);
      var opts = CH.map(function (c) {
        return '<button type="button" class="eg-opt' + (cur === c.t ? ' is-picked' : '') + '" data-eg-pick="' + esc(c.t) + '" aria-pressed="' + (cur === c.t) + '">' + (c.img ? '<img src="' + esc(c.img) + '" alt="" loading="lazy">' : '<span class="eg-ph"></span>') + '<span>' + esc(c.t) + '</span></button>';
      }).join('');
      choice = '<div class="eg-choice"><p class="eg-ct">Choisissez ' + (slots.length > 1 ? 'vos posters cadeaux' : 'votre poster cadeau') + '</p><div class="eg-slots">' + slotBtns + '</div><div class="eg-opts">' + opts + '</div>' + (aT && aT.u ? '<a class="eg-all" href="' + esc(aT.u) + '">Voir tous les posters offerts à ce palier</a>' : '') + '<p class="eg-cn">Il arrive dans votre colis avec votre commande. Vous pouvez changer d’avis jusqu’au paiement.</p></div>';
    }

    el.innerHTML = '<div class="eg-box"><p class="eg-msg">' + msg + '</p><div class="eg-track"><i style="width:' + Math.min(100, t / max * 100).toFixed(1) + '%"></i></div><p class="eg-sub">' + sub + '</p><div class="eg-tiles">' + tiles + '</div>' +
      (el.getAttribute('data-note') ? '<p class="eg-note">' + esc(el.getAttribute('data-note')) + '</p>' : '') + '</div>' + choice + sug;
    var cfgNode = d.createElement('script'); cfgNode.type = 'application/json'; cfgNode.setAttribute('data-eg-config', ''); cfgNode.textContent = JSON.stringify(cfg); el.appendChild(cfgNode);
    el.setAttribute('data-ready', '1');
  }
  function renderAll() { d.querySelectorAll('[data-eceo-gifts]').forEach(render); }

  function cleanAttrs() {
    // Retire le choix d'un poster cadeau si le palier n'est plus atteint
    var el = d.querySelector('[data-eceo-gifts]'); if (!el || total == null || !attrs) return;
    var T = tiersOf(el, attrs), up = {}, need = false;
    T.forEach(function (tr) { if (isSlot(tr) && total < tr.v * 100 && attrs[slotKey(tr)]) { up[slotKey(tr)] = ''; need = true; } });
    (cfgOf(el).tiers || []).forEach(function (tr) { if (isSlot(tr) && T.indexOf(tr) === -1 && attrs[slotKey(tr)]) { up[slotKey(tr)] = ''; need = true; } });
    if (need) setAttrs(up);
  }
  function setAttrs(obj) {
    attrs = Object.assign({}, attrs || {}, obj);
    Object.keys(obj).forEach(function (k) { if (!obj[k]) delete attrs[k]; });
    renderAll();
    return orig(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: obj }) }).catch(function () {});
  }
  // Relit le panier deux fois (tout de suite puis un peu plus tard) : certaines mises à jour du thème arrivent en décalé
  var pending2 = null;
  function pull() {
    orig(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { total = c.items_subtotal_price; attrs = c.attributes || {}; inCart = (c.items || []).map(function (i) { return i.product_id; }); renderAll(); cleanAttrs(); })
      .catch(function () {});
  }
  function refresh() {
    clearTimeout(pending); clearTimeout(pending2);
    pending = setTimeout(pull, 250);
    pending2 = setTimeout(pull, 1500);
  }
  // Toute modification du panier (thème, Mon mur, applis) relance le calcul
  var orig = window.fetch.bind(window);
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = orig.apply(window, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(refresh, refresh);
    return p;
  };
  ['cart:update', 'cart:updated', 'cart:refresh', 'cart:open'].forEach(function (n) { d.addEventListener(n, refresh); });
  // Boutons + / - / supprimer du panier : relecture aussi, au cas où le thème passerait par un autre chemin
  d.addEventListener('click', function (e) { if (e.target.closest('cart-drawer [name="plus"], cart-drawer [name="minus"], cart-drawer [data-ref="remove-item"], cart-drawer [data-ref="add-to-cart-button"], .eceo-up button')) setTimeout(refresh, 300); }, true);
  new MutationObserver(function () {
    var fresh = d.querySelectorAll('[data-eceo-gifts]:not([data-ready])');
    if (fresh.length) {
      // Panier re-rendu par le serveur : son montant est à jour, on le prend tout de suite puis on revérifie
      var srv = parseInt(fresh[0].getAttribute('data-total') || '', 10);
      if (!isNaN(srv)) total = srv;
      fresh.forEach(function (x) { x._cfg = null; });
      fresh.forEach(render);
      refresh();
    }
    syncButtons();
  }).observe(d.documentElement, { childList: true, subtree: true });

  d.addEventListener('click', function (e) {
    var add = e.target.closest('[data-eg-add]');
    if (add) {
      e.preventDefault();
      add.disabled = true;
      var cd = d.querySelector('cart-drawer'), sections = cd && cd.dataset.sectionId ? [cd.dataset.sectionId] : [];
      orig(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +add.getAttribute('data-eg-add'), quantity: 1, properties: { _source: 'Barre cadeaux' } }], sections: sections.join(',') }) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          refresh();
          if (cd && res.sections) {
            // Événement du thème construit à la main : un import dynamique est transformé par Shopify en require() et casse en ligne (la page se rechargeait et fermait le panier)
            d.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { resource: {}, data: { source: 'eceo-gifts', sections: res.sections } } }));
            d.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
          } else if (!cd) { location.href = root + 'cart'; }
        })
        .catch(function () { add.disabled = false; });
      return;
    }
    var slot = e.target.closest('[data-eg-slot]');
    if (slot) { var el = slot.closest('[data-eceo-gifts]'); el._slot = slot.getAttribute('data-eg-slot'); render(el); return; }
    var pick = e.target.closest('[data-eg-pick]');
    if (pick) {
      var g = pick.closest('[data-eceo-gifts]'), key = g._slot, o = {};
      if (!key) return;
      o[key] = pick.getAttribute('data-eg-pick');
      d.querySelectorAll('[data-eceo-gifts]').forEach(function (x) { x._slot = null; });
      setAttrs(o);
    }
  });

  /* ---------- Mon mur ---------- */
  d.addEventListener('click', function (e) {
    var a = e.target.closest('[data-eceo-mur]');
    if (!a) return;
    e.preventDefault();
    var mm = window.MonMur;
    if (!mm) { location.href = '/pages/mon-mur'; return; }
    var vid = a.getAttribute('data-variant'), pid = a.getAttribute('data-product');
    if (a.hasAttribute('data-current')) {
      var inp = d.querySelector('product-form input[name="id"]');
      if (inp && inp.value) vid = inp.value;
    }
    if (!vid && !pid) { mm.open(); return; }
    Promise.resolve(mm.addVariant(vid, pid)).then(function (it) {
      if (!it) return;
      d.dispatchEvent(new CustomEvent('toast:open', { detail: { type: 'success', message: 'Ajoutée à votre mur.' } }));
      mm.open();
    });
  });

  function init() {
    syncButtons();
    // Lien de l'e-mail de bienvenue (?bienvenue=1) : marque le panier pour débloquer le palier de bienvenue
    try {
      if (/[?&]bienvenue=/.test(location.search)) {
        var o = { _bienvenue: '1' };
        attrs = Object.assign({}, attrs || {}, o);
        orig(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: o }) })
          .then(function () { d.dispatchEvent(new CustomEvent('toast:open', { detail: { type: 'success', message: (function () { var e = d.querySelector('[data-eceo-gifts]'), c = e && cfgOf(e); return c && c.welcome && c.welcome.type === 'stickers' ? 'Cadeau de bienvenue activé : votre planche de stickers sera glissée dans votre colis.' : 'Cadeau de bienvenue activé : votre poster se choisit dans le panier.'; })() } })); refresh(); })
          .catch(function () {});
      }
    } catch (e) {}
    renderAll(); refresh();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
  window.EceoPP = { setMode: setMode, refreshGifts: refresh };
})();
